(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["a-product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('l-product-card')) {
		class LTAProductCard extends HTMLElement {
			/** Only one Quick Add panel open across all cards */
			static activeQuickAddCard = null

			/* ----------------------------------------------------------
			 * Color swatches — media swap + Quick Add color sync
			 * ---------------------------------------------------------- */
			_onSwatchClick = (event) => {
				const swatchEl = event.currentTarget
				const imageSet = swatchEl.dataset.imageSet
				const mediaId = swatchEl.dataset.mediaId

				this._swatchEls.forEach((el) => {
					const isActive = el === swatchEl
					el.classList.toggle('is-active', isActive)
					if (el.hasAttribute('aria-pressed')) {
						el.setAttribute('aria-pressed', isActive ? 'true' : 'false')
					}
				})

				if (this._hasImageSets) {
					this._setActiveImageSet(imageSet || 'default')
				} else if (mediaId) {
					this._setActiveMedia(mediaId)
				}

				this._syncCombinedProductLinks(swatchEl)

				if (this.dataset.quickAddMode === 'color_size') {
					this._selectedColor = swatchEl.dataset.optionValue || this._selectedColor
					this._syncQuickAddVariant()
				} else if (this.dataset.quickAddMode === 'single_option') {
					this._selectedOption = swatchEl.dataset.optionValue || this._selectedOption
					this._syncQuickAddVariant()
				}
			}

			/* ----------------------------------------------------------
			 * Quick Add panel — open / close / option select
			 * ---------------------------------------------------------- */
			_onQuickAddToggle = (event) => {
				event.preventDefault()
				event.stopPropagation()
				this._setQuickAddOpen(!this._isQuickAddOpen)
			}

			_onOptionClick = (event) => {
				const optionEl = event.currentTarget

				if (optionEl.disabled) return

				this._optionEls.forEach((el) => el.classList.toggle('is-active', el === optionEl))

				if (this.dataset.quickAddMode === 'color_size') {
					this._selectedSize = optionEl.dataset.optionValue
				} else {
					this._selectedOption = optionEl.dataset.optionValue
				}

				this._syncQuickAddVariant()
			}

			_onDocumentClick = (event) => {
				if (!this._isQuickAddOpen) return
				if (this.contains(event.target)) return

				this._setQuickAddOpen(false)
			}

			_onMediaMouseLeave = () => {
				if (!this._isQuickAddOpen) return

				this._setQuickAddOpen(false)
			}

			_onProductAdded = (event) => {
				if (!this._isQuickAddOpen) return
				if (event.detail?.id !== 'l-atc-button') return
				this._setQuickAddOpen(false)
			}

			/* ----------------------------------------------------------
			 * Lifecycle
			 * ---------------------------------------------------------- */
			connectedCallback() {
				this._abort = new AbortController()
				this._mediaEls = [...this.querySelectorAll('[data-product-media]')]
				this._swatchEls = [...this.querySelectorAll('[data-swatch-trigger]')]
				this._mediaEl = this.querySelector('.l-cPCard__media')
				this._mediaStackEl = this.querySelector('.l-cPCard__mediaStack')
				this._imageSetEls = [...(this._mediaStackEl?.querySelectorAll('[data-image-set]') || [])]
				this._paginationEl = this.querySelector('[data-card-pagination]')
				this._hasImageSets = this._imageSetEls.length > 0
				this._toggleEl = this.querySelector('[data-quick-add-toggle]')
				this._panelEl = this.querySelector('[data-quick-add-panel]')
				this._optionEls = [...this.querySelectorAll('[data-quick-add-option]')]
				this._atcEl = this.querySelector('[data-quick-add-atc]')
				this._atcButtonEl = this._atcEl?.querySelector('[data-atc-trigger]')
				this._atcTextEl = this._atcButtonEl?.querySelector('[data-add-to-cart-text]')
				this._isQuickAddOpen = false
				this._quickAddMode = this.dataset.quickAddMode

				// Swatches — always wire media / image-set swap
				this._swatchEls.forEach((swatchEl) => {
					swatchEl.addEventListener('click', this._onSwatchClick, { signal: this._abort.signal })
				})

				let activeSwatchEl = this._swatchEls.find((swatchEl) => swatchEl.classList.contains('is-active'))

				// Activate first color option by default when none is selected
				if (!activeSwatchEl && this._swatchEls.length) {
					activeSwatchEl = this._swatchEls[0]
					this._swatchEls.forEach((el) => {
						const isActive = el === activeSwatchEl
						el.classList.toggle('is-active', isActive)
						if (el.hasAttribute('aria-pressed')) {
							el.setAttribute('aria-pressed', isActive ? 'true' : 'false')
						}
					})
				}

				if (this._hasImageSets) {
					this._setActiveImageSet(
						activeSwatchEl?.dataset.imageSet || this._mediaStackEl?.dataset.activeSet || 'default'
					)
				} else {
					this._setActiveMedia(activeSwatchEl?.dataset.mediaId || this._mediaEls[0]?.dataset.mediaId)
				}

				if (activeSwatchEl) {
					this._syncCombinedProductLinks(activeSwatchEl)
				}

				// Inline Quick Add — color_size + single_option only
				if (this._quickAddMode === 'color_size' || this._quickAddMode === 'single_option') {
					this._variants = JSON.parse(this.querySelector('[data-quick-add-variants]')?.textContent || '[]')

					if (this._quickAddMode === 'color_size') {
						this._colorOptionPosition = Number(this.dataset.colorOptionPosition) - 1
						this._sizeOptionPosition = Number(this.dataset.sizeOptionPosition) - 1
						this._selectedColor =
							activeSwatchEl?.dataset.optionValue ||
							this.dataset.selectedColor ||
							this._swatchEls[0]?.dataset.optionValue ||
							''
						this._selectedSize =
							this._optionEls.find((el) => el.classList.contains('is-active'))?.dataset.optionValue ||
							this.dataset.selectedSize ||
							this._optionEls.find((el) => !el.disabled)?.dataset.optionValue ||
							''
					} else {
						// single_option
						this._optionPosition = Number(this.dataset.optionPosition) - 1
						this._selectedOption =
							this._optionEls.find((el) => el.classList.contains('is-active'))?.dataset.optionValue ||
							activeSwatchEl?.dataset.optionValue ||
							this.dataset.selectedOption ||
							this._optionEls.find((el) => !el.disabled)?.dataset.optionValue ||
							''
					}

					this._toggleEl?.addEventListener('click', this._onQuickAddToggle, { signal: this._abort.signal })
					this._panelEl?.addEventListener('click', (event) => event.stopPropagation(), { signal: this._abort.signal })
					this._optionEls.forEach((optionEl) => {
						optionEl.addEventListener('click', this._onOptionClick, { signal: this._abort.signal })
					})
					this._mediaEl?.addEventListener('mouseleave', this._onMediaMouseLeave, { signal: this._abort.signal })
					document.addEventListener('click', this._onDocumentClick, { signal: this._abort.signal })
					document.addEventListener('l:product:added', this._onProductAdded, { signal: this._abort.signal })
					this._syncQuickAddVariant()
				}
			}

			disconnectedCallback() {
				if (LTAProductCard.activeQuickAddCard === this) {
					LTAProductCard.activeQuickAddCard = null
				}

				this._abort?.abort()
			}

			/* ----------------------------------------------------------
			 * Helpers — media + Quick Add variant sync
			 * ---------------------------------------------------------- */
			_syncCombinedProductLinks(swatchEl) {
				const productUrl = swatchEl?.dataset.productUrl
				if (!productUrl) return

				const productTitle = swatchEl.dataset.productTitle || ''
				const mediaLinkEl = this.querySelector('.l-cPCard__media-link')
				const nameLinkEl = this.querySelector('.l-cPCard__name')

				if (mediaLinkEl) {
					mediaLinkEl.setAttribute('href', productUrl)
					if (productTitle) mediaLinkEl.setAttribute('aria-label', productTitle)
				}

				if (nameLinkEl) {
					nameLinkEl.setAttribute('href', productUrl)
					if (productTitle) {
						nameLinkEl.setAttribute('aria-label', productTitle)
						nameLinkEl.textContent = productTitle
					}
				}
			}

			_setActiveMedia(mediaId) {
				if (!mediaId) return

				this._mediaEls.forEach((mediaEl) => {
					mediaEl.classList.toggle('is-active', mediaEl.dataset.mediaId === mediaId)
				})
			}

			_setActiveImageSet(setKey) {
				if (!this._hasImageSets) return

				const requestedKey = setKey || 'default'
				const matchedEl =
					this._imageSetEls.find((el) => el.dataset.imageSet === requestedKey) ||
					this._imageSetEls.find((el) => el.dataset.imageSet === 'default')

				if (!matchedEl) return

				const activeKey = matchedEl.dataset.imageSet || 'default'

				this._imageSetEls.forEach((el) => {
					el.hidden = el !== matchedEl
				})

				if (this._mediaStackEl) {
					this._mediaStackEl.dataset.activeSet = activeKey
				}

				const hasSecondary = Boolean(matchedEl.querySelector('.l-cPCard__lifestyle'))

				if (this._paginationEl) {
					this._paginationEl.hidden = !hasSecondary
				}
			}

			_setQuickAddOpen(isOpen) {
				if (isOpen && LTAProductCard.activeQuickAddCard && LTAProductCard.activeQuickAddCard !== this) {
					LTAProductCard.activeQuickAddCard._setQuickAddOpen(false)
				}

				this._isQuickAddOpen = isOpen
				this._mediaEl?.classList.toggle('is-quick-add-open', isOpen)

				if (this._panelEl) {
					this._panelEl.hidden = !isOpen
					this._panelEl.classList.toggle('l-hidden', !isOpen)
				}

				if (this._toggleEl) {
					this._toggleEl.setAttribute('aria-expanded', isOpen ? 'true' : 'false')
				}

				LTAProductCard.activeQuickAddCard = isOpen ? this : null
			}

			_findVariant() {
				if (this._quickAddMode === 'single_option') {
					return this._variants.find((variant) => {
						const options = variant.options || []

						return options[this._optionPosition] === this._selectedOption
					})
				}

				// color_size
				return this._variants.find((variant) => {
					const options = variant.options || []

					return (
						options[this._colorOptionPosition] === this._selectedColor &&
						options[this._sizeOptionPosition] === this._selectedSize
					)
				})
			}

			_syncQuickAddVariant() {
				const selectedValue = this._quickAddMode === 'single_option' ? this._selectedOption : this._selectedSize

				this._optionEls.forEach((optionEl) => {
					const optionValue = optionEl.dataset.optionValue
					const match = this._variants.find((variant) => {
						const options = variant.options || []

						if (this._quickAddMode === 'single_option') {
							return options[this._optionPosition] === optionValue
						}

						return (
							options[this._colorOptionPosition] === this._selectedColor &&
							options[this._sizeOptionPosition] === optionValue
						)
					})

					optionEl.disabled = !match?.available
					optionEl.classList.toggle('is-active', optionValue === selectedValue && Boolean(match?.available))
				})

				const activeOptionEl = this._optionEls.find((el) => el.classList.contains('is-active') && !el.disabled)

				if (!activeOptionEl) {
					const firstAvailable = this._optionEls.find((el) => !el.disabled)

					this._optionEls.forEach((el) => el.classList.toggle('is-active', el === firstAvailable))

					if (this._quickAddMode === 'single_option') {
						this._selectedOption = firstAvailable?.dataset.optionValue || ''
					} else {
						this._selectedSize = firstAvailable?.dataset.optionValue || ''
					}
				} else if (this._quickAddMode === 'single_option') {
					this._selectedOption = activeOptionEl.dataset.optionValue
				} else {
					this._selectedSize = activeOptionEl.dataset.optionValue
				}

				const variant = this._findVariant()

				if (this._atcEl && variant) {
					this._atcEl.dataset.variantId = String(variant.id)
				}

				if (this._atcButtonEl) {
					this._atcButtonEl.disabled = !variant?.available
				}

				if (this._atcTextEl) {
					this._atcTextEl.textContent = variant?.available
						? this._atcButtonEl?.dataset.labelAvailable || this._atcTextEl.textContent
						: this._atcButtonEl?.dataset.labelSoldOut || 'Sold out'
				}
			}
		}

		customElements.define('l-product-card', LTAProductCard)
	}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["a-product-media-gallery"] && !Shopify.designMode) return;
  try {
    ;(() => {
		function lProductMediaHandleize(value) {
			return String(value || '')
				.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '')
				.toLowerCase()
				.trim()
				.replace(/['’]/g, '')
				.replace(/[^a-z0-9]+/g, '-')
				.replace(/^-+|-+$/g, '')
		}

		function lProductMediaParseSetKeys(hostEl) {
			const configEl = hostEl.querySelector('[data-variant-images-config]')

			if (!configEl) return []

			try {
				const config = JSON.parse(configEl.textContent)
				return Array.isArray(config.setKeys) ? config.setKeys : []
			} catch {
				return []
			}
		}

		function lProductMediaFormOptionValues(productInfo) {
			const variantSelects = productInfo?.querySelector('variant-selects')

			if (!variantSelects) return []

			const radios = [...variantSelects.querySelectorAll('fieldset input:checked')]
			const popouts = [...variantSelects.querySelectorAll('[data-popout-input]')]

			return [...radios, ...popouts].map((el) => el.value).filter(Boolean)
		}

		function lProductMediaOptionValues(productInfo, variant) {
			if (variant?.options?.length) return variant.options

			return lProductMediaFormOptionValues(productInfo)
		}

		function lProductMediaSetKey(setKeys, optionValues) {
			if (!setKeys?.length || !optionValues?.length) return null

			for (const optionValue of optionValues) {
				const key = lProductMediaHandleize(optionValue)

				if (key && setKeys.includes(key)) return key
			}

			return null
		}

		class LProductMediaGallery extends HTMLElement {
			constructor() {
				super()

				this._onVariantChange = this._onVariantChange.bind(this)
				this._onOptionChange = this._onOptionChange.bind(this)
			}

			connectedCallback() {
				this.carouselEl = this.querySelector('l-swiper-carousel')
				this.activeEl = this.querySelector('[data-gallery-active]')
				this.slideEls = [...(this.activeEl?.querySelectorAll('[data-media-id]') || [])]
				this.productInfo = this.closest('product-info')
				this._variantImageSetKeys = lProductMediaParseSetKeys(this)
				this._activeSetKey = this.dataset.activeSet || 'default'

				if (window.subscribe && window.theme?.PUB_SUB_EVENTS?.variantChange) {
					this._variantUnsub = subscribe(theme.PUB_SUB_EVENTS.variantChange, this._onVariantChange)
				}

				if (window.subscribe && window.theme?.PUB_SUB_EVENTS?.optionValueSelectionChange) {
					this._optionUnsub = subscribe(theme.PUB_SUB_EVENTS.optionValueSelectionChange, this._onOptionChange)
				}

				if (this._activeSetKey === 'default') {
					const initialMediaId = this._getFeaturedMediaId()

					if (initialMediaId) {
						this.goToMedia(initialMediaId)
					}
				}
			}

			disconnectedCallback() {
				this._variantUnsub?.()
				this._optionUnsub?.()
			}

			_getFeaturedMediaId() {
				const json = this.productInfo?.querySelector('[data-selected-variant]')?.textContent

				if (!json) return null

				try {
					const variant = JSON.parse(json)
					return variant?.featured_media?.id ?? null
				} catch {
					return null
				}
			}

			_applyVariantImageSet(setKey) {
				const setsRoot = this.querySelector('[data-gallery-sets]')
				const source = setsRoot?.querySelector(`[data-gallery-set="${setKey}"]`)

				if (!source || !this.activeEl) return

				if (typeof this.carouselEl?.destroyCarousel === 'function') {
					this.carouselEl.destroyCarousel()
				}

				this.activeEl.innerHTML = source.innerHTML
				this._activeSetKey = source.dataset.gallerySet || setKey
				this.dataset.activeSet = this._activeSetKey
				this.slideEls = [...this.activeEl.querySelectorAll('[data-media-id]')]

				if (typeof this.carouselEl?.refresh === 'function') {
					this.carouselEl.refresh()
				}

				if (typeof this.carouselEl?.slideTo === 'function') {
					this.carouselEl.slideTo(0, 0)
				}
			}

			_goToSlide(mediaId) {
				const index = this.slideEls.findIndex((slideEl) => String(slideEl.dataset.mediaId) === String(mediaId))

				if (index < 0 || !this.carouselEl) return

				const slideTo = () => {
					if (typeof this.carouselEl.slideTo === 'function') {
						this.carouselEl.slideTo(index, 0)
					}
				}

				if (this.carouselEl.swiperCarousel) {
					slideTo()
					return
				}

				this.carouselEl.addEventListener('l:swiper:carousel:loaded', slideTo, { once: true })

				const waitForSwiper = () => {
					if (this.carouselEl.swiperCarousel) {
						slideTo()
						return
					}

					requestAnimationFrame(waitForSwiper)
				}

				requestAnimationFrame(waitForSwiper)
			}

			_syncGallerySet(variant) {
				if (!this._variantImageSetKeys.length) return

				const optionValues = lProductMediaOptionValues(this.productInfo, variant)
				const setKey = lProductMediaSetKey(this._variantImageSetKeys, optionValues)

				if (!setKey || setKey === this._activeSetKey) return

				this._applyVariantImageSet(setKey)
			}

			_onOptionChange({ data }) {
				const variantSelects = data?.target?.closest?.('variant-selects')

				if (!this.productInfo || !variantSelects || !this.productInfo.contains(variantSelects)) return

				this._syncGallerySet()
			}

			_onVariantChange({ data }) {
				if (!this.productInfo) return

				const sectionId = this.productInfo.dataset.originalSection || this.productInfo.dataset.section

				if (data.sectionId && data.sectionId !== sectionId) return

				this._syncGallerySet(data?.variant)

				if (this._activeSetKey !== 'default') return

				const mediaId = data?.variant?.featured_media?.id

				if (mediaId) {
					this.goToMedia(mediaId)
				}
			}

			goToMedia(mediaId) {
				this._goToSlide(mediaId)
			}
		}

		if (!customElements.get('l-product-media-gallery')) {
			customElements.define('l-product-media-gallery', LProductMediaGallery)
		}

		class LProductMediaDesktop extends HTMLElement {
			constructor() {
				super()

				this._onVariantChange = this._onVariantChange.bind(this)
				this._onOptionChange = this._onOptionChange.bind(this)
				this._onToggle = this.onToggle.bind(this)
			}

			connectedCallback() {
				this.productInfo = this.closest('product-info')
				this.gridEl = this.querySelector('[data-grid]')
				this.toggleBtn = this.querySelector('[data-toggle]')
				this.labelEl = this.toggleBtn?.querySelector('[data-toggle-label]')
				this.moreText = this.toggleBtn?.dataset.more
				this.lessText = this.toggleBtn?.dataset.less
				this._variantImageSetKeys = lProductMediaParseSetKeys(this)
				this._activeSetKey = this.dataset.activeSet || 'default'

				if (window.subscribe && window.theme?.PUB_SUB_EVENTS?.variantChange) {
					this._variantUnsub = subscribe(theme.PUB_SUB_EVENTS.variantChange, this._onVariantChange)
				}

				if (window.subscribe && window.theme?.PUB_SUB_EVENTS?.optionValueSelectionChange) {
					this._optionUnsub = subscribe(theme.PUB_SUB_EVENTS.optionValueSelectionChange, this._onOptionChange)
				}

				this.classList.add('is-collapsed')
				this._recalculateRows()
				this.toggleBtn?.addEventListener('click', this._onToggle)

				if (this._activeSetKey === 'default') {
					const initialMediaId = this._getFeaturedMediaId()

					if (initialMediaId) {
						this.goToMedia(initialMediaId)
					}
				}
			}

			disconnectedCallback() {
				this._variantUnsub?.()
				this._optionUnsub?.()
				this.toggleBtn?.removeEventListener('click', this._onToggle)
			}

			_getFeaturedMediaId() {
				const json = this.productInfo?.querySelector('[data-selected-variant]')?.textContent

				if (!json) return null

				try {
					const variant = JSON.parse(json)
					return variant?.featured_media?.id ?? null
				} catch {
					return null
				}
			}

			_applyVariantImageSet(setKey) {
				const setsRoot = this.querySelector('[data-gallery-sets]')
				const source = setsRoot?.querySelector(`[data-gallery-set="${setKey}"]`)

				if (!source || !this.gridEl) return

				this.gridEl.innerHTML = source.innerHTML
				this._activeSetKey = source.dataset.gallerySet || setKey
				this.dataset.activeSet = this._activeSetKey
				this.classList.add('is-collapsed')

				if (this.labelEl && this.moreText) {
					this.labelEl.textContent = this.moreText
				}

				this._recalculateRows()
			}

			_isAlwaysFullWidth(columnEl) {
				const type = columnEl.dataset.mediaType

				return type === 'video' || type === 'external_video' || type === 'model'
			}

			_demoteFeaturedColumn(columnEl) {
				columnEl.removeAttribute('data-featured')

				if (this._isAlwaysFullWidth(columnEl)) return

				columnEl.removeAttribute('data-span')
				columnEl.classList.remove('l-pMediaDesk__column--full')
			}

			_promoteFeaturedColumn(columnEl) {
				if (!this.gridEl || columnEl.hasAttribute('data-featured')) return

				const currentFeatured = this.gridEl.querySelector('[data-featured]')

				if (currentFeatured) this._demoteFeaturedColumn(currentFeatured)

				columnEl.setAttribute('data-featured', '')
				columnEl.setAttribute('data-span', 'full')
				columnEl.classList.add('l-pMediaDesk__column--full')
				this.gridEl.prepend(columnEl)
				this._recalculateRows()
			}

			_recalculateRows() {
				if (!this.gridEl) return

				const maxRows = Number(this.dataset.maxRows) || 4
				const columnEls = [...this.gridEl.querySelectorAll('[data-media]')]
				let row = 1
				let col = 0

				columnEls.forEach((columnEl) => {
					const isFull = columnEl.getAttribute('data-span') === 'full' || this._isAlwaysFullWidth(columnEl)

					if (isFull) {
						if (col > 0) {
							row += 1
							col = 0
						}

						columnEl.dataset.row = String(row)
						row += 1
						return
					}

					columnEl.dataset.row = String(row)
					col += 1

					if (col === 2) {
						row += 1
						col = 0
					}
				})

				const totalRows = col > 0 ? row : row - 1

				columnEls.forEach((columnEl) => {
					const isHidden = Number(columnEl.dataset.row) > maxRows

					columnEl.classList.toggle('l-pMediaDesk__column--hidden', isHidden)

					if (isHidden) {
						columnEl.setAttribute('data-row-hidden', '')
					} else {
						columnEl.removeAttribute('data-row-hidden')
					}
				})

				if (!this.toggleBtn) return

				const hasExtraRows = totalRows > maxRows

				this.toggleBtn.hidden = !hasExtraRows
				this.toggleBtn.classList.toggle('l-hidden', !hasExtraRows)

				if (!hasExtraRows) {
					this.classList.remove('is-collapsed')
				}
			}

			_syncGallerySet(variant) {
				if (!this._variantImageSetKeys.length) return

				const optionValues = lProductMediaOptionValues(this.productInfo, variant)
				const setKey = lProductMediaSetKey(this._variantImageSetKeys, optionValues)

				if (!setKey || setKey === this._activeSetKey) return

				this._applyVariantImageSet(setKey)
			}

			_onOptionChange({ data }) {
				const variantSelects = data?.target?.closest?.('variant-selects')

				if (!this.productInfo || !variantSelects || !this.productInfo.contains(variantSelects)) return

				this._syncGallerySet()
			}

			_onVariantChange({ data }) {
				if (!this.productInfo) return

				const sectionId = this.productInfo.dataset.originalSection || this.productInfo.dataset.section

				if (data.sectionId && data.sectionId !== sectionId) return

				this._syncGallerySet(data?.variant)

				if (this._activeSetKey !== 'default') return

				const mediaId = data?.variant?.featured_media?.id

				if (mediaId) {
					this.goToMedia(mediaId)
				}
			}

			goToMedia(mediaId) {
				const columnEl = this.gridEl?.querySelector(`[data-media-id="${mediaId}"]`)

				if (!columnEl) return

				if (this.dataset.layout === 'featured') {
					this._promoteFeaturedColumn(columnEl)
					return
				}

				if (columnEl.hasAttribute('data-row-hidden') && this.classList.contains('is-collapsed')) {
					this.classList.remove('is-collapsed')

					if (this.labelEl && this.lessText) {
						this.labelEl.textContent = this.lessText
					}
				}
			}

			onToggle() {
				const isCollapsed = this.classList.toggle('is-collapsed')

				if (this.labelEl) {
					this.labelEl.textContent = isCollapsed ? this.moreText : this.lessText
				}

				// After "Show less", bring the gallery back into view
				if (isCollapsed) this.scrollToTop()
			}

			scrollToTop() {
				const rect = this.getBoundingClientRect()

				// Already in view — no need to scroll
				if (rect.top >= 0) return

				const styles = getComputedStyle(document.documentElement)
				const headerOffset =
					parseInt(styles.getPropertyValue('--l-header-height')) ||
					parseInt(styles.getPropertyValue('--header-height')) ||
					0

				window.scrollTo({
					top: window.scrollY + rect.top - headerOffset - 20,
					behavior: 'smooth',
				})
			}
		}

		if (!customElements.get('l-pmedia-desktop')) {
			customElements.define('l-pmedia-desktop', LProductMediaDesktop)
		}
	})()

	class LTAProductModalExternalMedia extends HTMLElement {
		constructor() {
			super()

			this.boundPlayHandler = this.onPlayClick.bind(this)
		}

		connectedCallback() {
			this.templateEl = this.querySelector('template')
			this.posterEl = this.querySelector('[data-external-media-poster]')
			this.playBtn = this.querySelector('[data-external-media-play]')

			this.playBtn?.addEventListener('click', this.boundPlayHandler)
		}

		disconnectedCallback() {
			this.playBtn?.removeEventListener('click', this.boundPlayHandler)
			this.clearPlayFallback()
		}

		onPlayClick(event) {
			event.preventDefault()
			event.stopPropagation()

			if (!this.classList.contains('is-loaded')) {
				this.loadContent()
				return
			}

			this.playVideo()
		}

		loadContent() {
			if (this.classList.contains('is-loaded') || !this.templateEl) return

			const content = this.templateEl.content.cloneNode(true)

			this.appendChild(content)
			this.classList.add('is-loaded')
			this.posterEl?.setAttribute('hidden', '')

			this.playMediaWhenReady()
		}

		clearPlayFallback() {
			if (!this._playFallbackTimer) return

			window.clearTimeout(this._playFallbackTimer)
			this._playFallbackTimer = 0
		}

		playMediaWhenReady() {
			const iframeEl = this.querySelector('iframe')

			if (iframeEl) {
				this.playIframeWhenReady(iframeEl)
				return
			}

			l_playMedia(this)
		}

		playIframeWhenReady(iframeEl) {
			let hasPlayed = false

			const playOnce = () => {
				if (hasPlayed) return

				hasPlayed = true
				this.clearPlayFallback()
				l_playMedia(this)
			}

			iframeEl.addEventListener(
				'load',
				() => {
					window.setTimeout(playOnce, 200)
				},
				{ once: true }
			)

			this._playFallbackTimer = window.setTimeout(playOnce, 600)
		}

		playVideo() {
			if (!this.classList.contains('is-loaded')) {
				this.loadContent()
				return
			}

			l_playMedia(this)
		}

		pauseVideo() {
			this.querySelectorAll('.js-youtube').forEach((youtubeVideo) => {
				youtubeVideo.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
			})
			this.querySelectorAll('.js-vimeo').forEach((vimeoVideo) => {
				vimeoVideo.contentWindow.postMessage('{"method":"pause"}', '*')
			})
		}
	}

	if (!customElements.get('l-external-media')) {
		customElements.define('l-external-media', LTAProductModalExternalMedia)
	}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-block-bullet-points"] && !Shopify.designMode) return;
  try {
    class LBulletList extends HTMLElement {
		connectedCallback() {
			const template = this.querySelector('[data-bullet-icon]')

			if (!template || !template.content) return

			this.querySelectorAll('ul > li').forEach((item) => {
				if (item.querySelector('.l-pBullets__icon')) return

				const icon = document.createElement('span')
				icon.className = 'l-pBullets__icon'
				icon.setAttribute('aria-hidden', 'true')
				icon.appendChild(template.content.cloneNode(true))
				item.prepend(icon)
			})
		}
	}

	if (!customElements.get('l-bullet-list')) {
		customElements.define('l-bullet-list', LBulletList)
	}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-combined-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('l-combined-products')) {
		const l_combinedProductsCache = new Map()

		class LTACombinedProducts extends HTMLElement {
			constructor() {
				super()
				this._onChange = this._onChange.bind(this)
				this._onPopState = this._onPopState.bind(this)
				this._cleanups = []
				this._activeRequestId = null
				this.abortController = null
			}

			connectedCallback() {
				this.addEventListener('change', this._onChange)
				window.addEventListener('popstate', this._onPopState)

				this._cleanups.push(() => {
					this.removeEventListener('change', this._onChange)
					window.removeEventListener('popstate', this._onPopState)
				})
			}

			disconnectedCallback() {
				this._cleanups.forEach((fn) => fn())
				this._cleanups = []
				this.abortController?.abort()
			}

			_onChange(event) {
				const input = event.target
				if (!(input instanceof HTMLInputElement)) return
				if (!input.matches('[data-combined-product-url]')) return

				const url = input.dataset.combinedProductUrl
				if (!url) return

				const labelEl = this.querySelector('[data-combined-selected-value]')
				if (labelEl && input.dataset.combinedProductLabel) {
					labelEl.textContent = input.dataset.combinedProductLabel
				}

				const currentPath = `${window.location.pathname}${window.location.search}`
				const nextUrl = new URL(url, window.location.origin)
				const nextPath = `${nextUrl.pathname}${nextUrl.search}`

				if (currentPath === nextPath) return

				this._navigateToProduct(nextUrl.toString(), true, true)
			}

			_onPopState() {
				this._navigateToProduct(window.location.href, false, false)
			}

			_navigateToProduct(fetchUrl, updateHistory = true, cacheCurrentPage = true) {
				if (cacheCurrentPage) this._cacheCurrentPage()

				const cacheKey = this._getCacheKey(fetchUrl)
				const cached = l_combinedProductsCache.get(cacheKey)

				if (cached) {
					this._renderCachedPage(cached, cacheKey, updateHistory)
					return
				}

				const requestId = Symbol('combined-products')
				this._activeRequestId = requestId
				this._showLoading()

				this.abortController?.abort()
				this.abortController = new AbortController()

				fetch(cacheKey, { signal: this.abortController.signal })
					.then((response) => {
						if (!response.ok) throw new Error(`Failed to fetch product: ${response.status}`)
						return response.text()
					})
					.then((html) => {
						if (this._activeRequestId !== requestId) return

						const pageData = this._parsePage(html)
						l_combinedProductsCache.set(cacheKey, pageData)

						if (updateHistory) {
							history.pushState({ combinedProducts: true }, '', cacheKey)
						}

						this._applyPage(pageData)
					})
					.catch((error) => {
						if (error.name === 'AbortError') return
						console.error('[LTACombinedProducts] Fetch error:', error)
						window.location.href = cacheKey
					})
					.finally(() => {
						if (this._activeRequestId === requestId) {
							this._hideLoading()
						}
					})
			}

			_renderCachedPage(pageData, cacheKey, updateHistory) {
				const requestId = Symbol('combined-products-cache')
				this._activeRequestId = requestId
				this._showLoading()

				window.setTimeout(() => {
					if (this._activeRequestId !== requestId) return

					try {
						if (updateHistory) {
							history.pushState({ combinedProducts: true }, '', cacheKey)
						}

						this._applyPage(pageData)
					} finally {
						this._hideLoading()
					}
				}, 400)
			}

			_getCacheKey(href) {
				const url = new URL(href, window.location.origin)
				return `${url.pathname}${url.search}`
			}

			_cacheCurrentPage() {
				const mainContentEl = document.getElementById('MainContent')
				if (!mainContentEl) return

				const cacheKey = this._getCacheKey(window.location.href)
				l_combinedProductsCache.set(cacheKey, {
					mainHTML: mainContentEl.innerHTML,
					title: document.title,
					canonical: document.querySelector('link[rel="canonical"]')?.getAttribute('href') || '',
				})
			}

			_showLoading() {
				document.documentElement.classList.add('is-product-loading')

				let overlay = document.querySelector('[data-product-loading]')
				if (overlay) return

				overlay = document.createElement('div')
				overlay.className = 'l-sPDP__loading'
				overlay.setAttribute('data-product-loading', '')
				overlay.setAttribute('role', 'status')
				overlay.setAttribute('aria-live', 'polite')
				overlay.innerHTML = `
					<span class="l-sPDP__loading-spinner" aria-hidden="true"></span>
					<span class="visually-hidden">Loading</span>
				`
				document.body.appendChild(overlay)
			}

			_hideLoading() {
				document.documentElement.classList.remove('is-product-loading')
				document.querySelector('[data-product-loading]')?.remove()
			}

			_parsePage(html) {
				const doc = new DOMParser().parseFromString(html, 'text/html')
				const newMain = doc.getElementById('MainContent')

				if (!newMain) {
					throw new Error('MainContent not found')
				}

				return {
					mainHTML: newMain.innerHTML,
					title: doc.title,
					canonical: doc.querySelector('link[rel="canonical"]')?.getAttribute('href') || '',
				}
			}

			_stripExecutableScripts(root) {
				root.querySelectorAll('script').forEach((script) => {
					const type = (script.getAttribute('type') || '').trim().toLowerCase()

					// Keep JSON data blocks (carousel config, variant JSON, etc.)
					if (type === 'application/json' || type === 'application/ld+json') return

					script.remove()
				})
			}

			_applyPage(pageData) {
				const currentMain = document.getElementById('MainContent')
				if (!currentMain || !pageData?.mainHTML) {
					throw new Error('MainContent not found')
				}

				const combinedEl = currentMain.querySelector('l-combined-products') || this
				const anchorTop = combinedEl.getBoundingClientRect().top

				const temp = document.createElement('div')
				temp.innerHTML = pageData.mainHTML
				this._stripExecutableScripts(temp)
				temp.querySelectorAll('.aos-animate').forEach((el) => el.classList.remove('aos-animate'))

				currentMain.innerHTML = temp.innerHTML
				document.title = pageData.title || document.title

				const currentCanonical = document.querySelector('link[rel="canonical"]')
				if (currentCanonical && pageData.canonical) {
					currentCanonical.setAttribute('href', pageData.canonical)
				}

				this._restoreScrollToCombined(currentMain, anchorTop)

				requestAnimationFrame(() => {
					this._restoreScrollToCombined(currentMain, anchorTop)
					this._reinitPage(currentMain)
					this._restoreScrollToCombined(currentMain, anchorTop)

					requestAnimationFrame(() => {
						this._restoreScrollToCombined(currentMain, anchorTop)
					})

					this._settleScrollAfterImages(currentMain, anchorTop)
				})
			}

			_restoreScrollToCombined(container, targetTop) {
				const nextCombinedEl = container.querySelector('l-combined-products')
				if (!nextCombinedEl) return

				const offsetDiff = nextCombinedEl.getBoundingClientRect().top - targetTop
				if (Math.abs(offsetDiff) > 1) {
					window.scrollBy(0, offsetDiff)
				}
			}

			_settleScrollAfterImages(container, targetTop) {
				const images = [...container.querySelectorAll('img')].filter((img) => !img.complete)
				if (!images.length) {
					this._restoreScrollToCombined(container, targetTop)
					return
				}

				let remaining = images.length
				const settle = () => {
					remaining -= 1
					this._restoreScrollToCombined(container, targetTop)
					if (remaining <= 0) {
						requestAnimationFrame(() => this._restoreScrollToCombined(container, targetTop))
					}
				}

				images.forEach((img) => {
					img.addEventListener('load', settle, { once: true })
					img.addEventListener('error', settle, { once: true })
				})

				window.setTimeout(() => this._restoreScrollToCombined(container, targetTop), 300)
			}

			_reinitPage(container) {
				const sectionEl = container.querySelector('.shopify-section')
				if (sectionEl) {
					sectionEl.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }))
				} else {
					window.dispatchEvent(new Event('resize'))
				}

				container.querySelectorAll('l-swiper-carousel').forEach((carousel) => {
					if (carousel.swiperCarousel) return
					carousel.refresh?.()
				})

				container.querySelectorAll('img.is-loading').forEach((img) => {
					if (!img.complete) return
					img.classList.remove('is-loading')
					img.parentElement?.classList.remove('is-loading')
				})

				if (typeof window.okeWidgetApi?.initAllWidgets === 'function') {
					window.okeWidgetApi.initAllWidgets()
				}

				if (window.Shopify?.PaymentButton) {
					window.Shopify.PaymentButton.init()
				}
			}
		}

		customElements.define('l-combined-products', LTACombinedProducts)
	}
  } catch(e) { console.error(e); }
})();

})();
